import { CheckOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const BookingQueueContainer = styled.div`
  // padding-bottom: 10px;
  .booking-queue-action-header {
    .right {
      & > * {
        flex: 1;
      }
    }
  }
  table {
  tr.selected{
  .anticon-check{
  color:rgb(69 255 69) !important;
  }
  }
  }
  .queue-action-header{
      position: relative;
      top: 0;
  }
  td{
    .cell-action-link,
    .cell-icon-state
    {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
  }
`;

export const StyledDotCicleIcon = styled.span`
     width: 10px;
    height: 10px;
    background: #a7dff7;
    border: 1px solid rgba(0, 0, 0, 0.06);
    display: inline-flex;
    border-radius: 100px;
`

export const StyledcCheckIcon = styled(CheckOutlined)`
  path{  
  stroke: red !important;
  stroke-width: 3px !important;
  }
`